import React, { useState } from 'react';

const YouTubeFrame = ({ videoUrl, title, language = 'de', showTitle = true, thumbnailIndex }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [thumbIdx, setThumbIdx] = useState(0);

  const getYouTubeId = (url) => {
    let videoId = null;
    if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1].split('&')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('embed/')[1].split('?')[0];
    }
    if (videoId && videoId.length === 11) {
      return videoId;
    }
    return null;
  };

  const videoId = getYouTubeId(videoUrl);

  // Vignettes candidates pour l'état non lu (favoriser images tardives 3,2,1,0)
  const buildThumbnailCandidates = () => {
    if (!videoId) return [];
    const base = `https://img.youtube.com/vi/${videoId}`;
    const laterFirst = [3, 2, 1, 0];
    const orderedIndices = typeof thumbnailIndex === 'number' ? [thumbnailIndex, ...laterFirst] : laterFirst;
    const uniqueIndices = Array.from(new Set(orderedIndices.filter((n) => n >= 0 && n <= 3)));
    const indexBased = uniqueIndices.map((n) => `${base}/${n}.jpg`);
    const qualityBased = [
      `${base}/maxresdefault.jpg`,
      `${base}/hqdefault.jpg`,
      `${base}/sddefault.jpg`,
      `${base}/mqdefault.jpg`,
    ];
    return [...qualityBased, ...indexBased];
  };

  const thumbnailCandidates = buildThumbnailCandidates();
  const resolvedThumbnailSrc = thumbnailCandidates[thumbIdx] || '';

  if (!videoId) {
    return (
      <div className="video-error">
        <p>Erreur: Impossible de charger la vidéo</p>
        <p>URL: {videoUrl}</p>
      </div>
    );
  }

  if (isPlaying) {
    return (
      <div className="youtube-frame-container">
        <div className="youtube-iframe-wrapper">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&hl=${language}`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="youtube-iframe"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    );
  }

  const handleThumbLoad = (e) => {
    const img = e?.target;
    if (!img) return;
    const isNumericThumb = /\/([0-3])\.jpg$/.test(img.src);
    const naturalWidth = img.naturalWidth || 0;
    if (isNumericThumb && naturalWidth < 400 && thumbIdx + 1 < thumbnailCandidates.length) {
      setThumbIdx(thumbIdx + 1);
    }
  };

  return (
    <div className="video-frame" onClick={() => setIsPlaying(true)}>
      <div className="video-thumbnail">
        <img
          src={resolvedThumbnailSrc}
          alt={title}
          className="video-thumbnail-img"
          loading="lazy"
          onError={() => setThumbIdx((prev) => (prev + 1 < thumbnailCandidates.length ? prev + 1 : prev))}
          onLoad={handleThumbLoad}
        />
        <div className="video-play-overlay">
          <div className="video-play-button">PLAY</div>
        </div>
      </div>
      {showTitle && <div className="video-frame-title">{title}</div>}
    </div>
  );
};

export default YouTubeFrame; 